import axios from 'axios';

import actionTypes from './actionTypes';
import store from '../store/store';
import { API_CONFIG } from '../../config/api.config';
import { PRODUCT_CONFIG } from '../../config/product.config';

const createHeaders = () => {
	const state = store.getState();
	const langTag = state.head.language.toUpperCase() || localStorage.getItem('lang').toUpperCase();
	const lang = (store.getState().head.utilities.languages.find(lng => lng.tag === langTag) || { uuid: localStorage.getItem('langUuid') || undefined }).uuid;
	const token = state.cms.authentication.token || localStorage.getItem('token');

	return { headers: { lang: lang || '489d6ac3-7b65-42c1-bdc6-67348bf7a112', token } };
};

export const fetchingFailed = () => (dispatch) => {
	dispatch({
		type: actionTypes.FETCHING_PRODUCT_FAILED,
	});
};
export const fetchingSucceeded = () => (dispatch) => {
	dispatch({
		type: actionTypes.FETCHING_PRODUCT_SUCCEEDED,
	});
};
export const fetchingInProgress = () => (dispatch) => {
	dispatch({
		type: actionTypes.FETCHING_PRODUCT_IN_PROGRESS,
	});
};

const createListFromProductInfo = (data) => {
	const product = data;

	product.productInfo = Object.keys(data)
		.filter(key => PRODUCT_CONFIG.fields.includes(key))
		.reduce((result, key) => {
			result.push({
				key,
				label: PRODUCT_CONFIG.label[key],
				value: data[key],
			});
			return result;
		}, [])
		.sort((a, b) => {
			const afield = PRODUCT_CONFIG.fields.indexOf(a.key);
			const bfield = PRODUCT_CONFIG.fields.indexOf(b.key);

			return afield - bfield;
		});
	return product;
};

export const checkIfProductsAreFetched = (dispatch) => {
	dispatch({
		type: actionTypes.CHECK_BEFORE_FETCH,
	});

	return store.getState().product.result.length > 1;
};

export const fetchProducts = () => (dispatch) => {
	dispatch(fetchingInProgress());

	if (checkIfProductsAreFetched(dispatch)) {
		return;
	}
	const head = createHeaders();
	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}`, head)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_PRODUCTS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchProductsAll = ({ force = false }) => (dispatch) => {
	dispatch(fetchingInProgress());

	if (checkIfProductsAreFetched(dispatch) && !force) {
		return;
	}
	const head = createHeaders();
	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT_ALL}`, head)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_PRODUCTS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const fetchProductsByCategory = slug => (dispatch) => {
	dispatch(fetchingInProgress());
	const head = createHeaders();
	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT_BY_CATEGORY}/${slug}`, head)
		.then((data) => {
			dispatch({
				type: actionTypes.FETCH_PRODUCTS_BY_CATEGORY,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const compareProduct = product => (dispatch) => {
	let type = actionTypes.COMPARE_PRODUCT_PRIMARY;

	if (store.getState().product.compare.primary) {
		type = actionTypes.COMPARE_PRODUCT_SECONDARY;
	}

	dispatch({
		type,
		product: createListFromProductInfo(product),
	});
};

export const removeCompareProduct = product => (dispatch) => {
	const type = store.getState().product.compare.primary.slug === product.slug ?
		actionTypes.REMOVE_COMPARE_PRODUCT_PRIMARY : actionTypes.REMOVE_COMPARE_PRODUCT_SECONDARY;

	dispatch({
		type,
	});
};

export const fetchProductBySlug = slug => (dispatch) => {
	dispatch(fetchingInProgress());

	const index = store.getState().product.result.findIndex(item => item.slug === slug);

	const head = createHeaders();
	if (index === -1) {
		axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}/${slug}`, head)
			.then((result) => {
				dispatch({
					type: actionTypes.FETCH_PRODUCT_BY_SLUG,
					data: {
						item: createListFromProductInfo(result.data.data),
					},
				});
				dispatch(fetchingSucceeded());
			})
			.catch(() => dispatch(fetchingFailed()));
		return;
	}

	dispatch({
		type: actionTypes.FETCH_PRODUCT_BY_SLUG,
		data: {
			item: createListFromProductInfo(store.getState().product.result[index]),
			index,
		},
	});
};

export const goToNextItem = () => (dispatch) => {
	dispatch(fetchingInProgress());

	const state = store.getState().product;
	const index = state.result.findIndex(value =>
		value.slug === state.selected.slug);

	if (index === -1 || (index + 1) >= state.result.length) {
		return;
	}

	const nextItem = state.result[index + 1];
	const head = createHeaders();

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}/${nextItem.slug}`, head)
		.then((result) => {
			dispatch({
				type: actionTypes.GO_TO_NEXT_ITEM,
				data: {
					item: createListFromProductInfo(result.data.data),
					index: index + 1,
				},
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};
export const goToPreviousItem = () => (dispatch) => {
	const state = store.getState().product;
	const index = state.result.findIndex(value =>
		value.slug === state.selected.slug);

	if (index === -1 || index === 0) {
		return;
	}

	const nextItem = state.result[index - 1];
	const head = createHeaders();

	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT}/${nextItem.slug}`, head)
		.then((result) => {
			dispatch({
				type: actionTypes.GO_TO_PREVIOUS_ITEM,
				data: {
					item: createListFromProductInfo(result.data.data),
					index: index - 1,
				},
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};

export const searchProduct = ({ slug, search }) => (dispatch) => {
	const head = createHeaders();

	dispatch(fetchingInProgress());
	axios.get(`${API_CONFIG.ROUTE}${API_CONFIG.PRODUCT_BY_CATEGORY}/${slug}/search/${search}`, head)
		.then((data) => {
			dispatch({
				type: actionTypes.SEARCH_PRODUCTS,
				data: data.data.data,
			});
			dispatch(fetchingSucceeded());
		})
		.catch(() => dispatch(fetchingFailed()));
};



// WEBPACK FOOTER //
// ./src/redux/product/productActions.js